<template>
  <div id="removeclass">
    <modal
      :modal-id="modalId"
      :title="modalTitle"
      :preloader="preloader"
      @submit="submit"
      @close-modal="closeModal"
    >
      <template slot="body">
        <app-overlay-loader v-if="preloader" />
        <form
          class="mb-0"
          :class="{ 'loading-opacity': preloader }"
          ref="form"
          :data-url="addUrl"
        >
          <div class="row">
            <div class="col-lg-6 col-md-6 col-sm-12">
              <div class="form-group">
                <label>{{ $t("forms") }}</label>
                <app-input
                  type="search-select"
                  :isAnimatedDropdown="true"
                  :placeholder="$t('forms')"
                  :list="this.forms"
                  v-model="inputs.form_id"
                  :required="true"
                />
                <p v-if="refreshShow == false" class="font-italic text-muted">
                    {{ $t("shortcut_form_create") }} <span><a href="#" @click.prevent="createForm()">{{$t("create_new")}}</a></span>
                  </p>
                  <p v-if="refreshShow == true" class="font-italic text-muted">
                    <a href="#" @click.prevent="refreshForm()">{{$t("refresh")}}</a><span> {{ $t("form_create_refresh") }}</span>                  </p>
              </div>
            </div>
            <div class="col-lg-6 col-md-6 col-sm-12">
              <div class="form-group">
                <label>{{ $t("title") }}</label>
                <app-input type="text"
                  placeholder="Enter Title"
                  v-model="inputs.title"
                  :required="true"
                 />

              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-12 col-md-12 col-sm-12">
              <div class="form-group">
                <label>{{ $t("description") }}</label>
                <app-input
                  type="textarea"
                  id="textarea-id"
                  placeholder="Short Desciption"
                  v-model="inputs.description"
                  :required="true"
                />
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-6 col-md-6 col-sm-12">
              <div class="form-group">
                <label>{{ $t("start_date") }}</label>
                <app-input
                  type="date"
                  v-model="inputs.start_date"
                  :placeholder="$t('select_valid_date')"
                />
              </div>
            </div>
            <div class="col-lg-6 col-md-6 col-sm-12">
              <div class="form-group">
                <label>{{ $t("due_date") }}</label>
                <app-input
                  type="date"
                  v-model="inputs.due_date"
                  :placeholder="$t('select_valid_date')"
                />
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-12 col-md-12 col-sm-12">
              <div class="form-group">
                <label>{{ $t("priority") }}</label>
                <app-input
                  type="radio"
                  :list="list"
                  v-model="inputs.priority"
                />
              </div>
            </div>
          </div>
        </form>
      </template>
    </modal>
  </div>
</template>

<script>
import { FormMixin } from "../../../../../../core/mixins/form/FormMixin";
import { ModalMixin } from "../../../../../../app/Mixins/ModalMixin";
import { axiosPost, axiosGet } from "../../../../../Helpers/AxiosHelper";
import AppLibrary from "../../../../../Helpers/AppLibrary";
import {
  BUYER_CERTIFICATE_FORMS,
  BUYER_CERTIFICATE_FORM_ASSIGN,
  JOB_FORM_ASSIGN,
} from "../../../../../Config/ApiUrl";

export default {
  name: "AddModal",
  extends:AppLibrary,
  mixins: [FormMixin, ModalMixin],
  props: {
    tableId: String,
    id: Number,
  },
  data() {
    return {
      refreshShow: false,
      addUrl: JOB_FORM_ASSIGN,
      preloader: false,
      inputs: {
        start_date: new Date(),
        due_date: new Date(),
      },
      forms: [],
      list: [
        {
          id: "High",
          value: "High",
        },
        {
          id: "Medium",
          value: "Medium",
        },
        {
          id: "Low",
          value: "Low",
        },
      ],
      modalId: "demo-add-edit-Modal",
      modalTitle: this.$t("add"),
    };
  },
  created() {
    if (this.selectedUrl) {
      this.modalTitle = this.$t("edit");
      this.preloader = true;
    }
  },
  methods: {
    submit() {
        this.inputs.type = 'bid';
        if (this.inputs.start_date) this.inputs.start_date = this.getDateFormatForBackend(this.inputs.start_date);
        if (this.inputs.due_date) this.inputs.due_date = this.getDateFormatForBackend(this.inputs.due_date);
      //   axiosPost(JOB_FORM_ASSIGN, this.inputs)
      //     .then((res) => {
            
      //       this.$toastr.s(res.data.message);
      //     })
      //     .catch((error) => {
            
      //       this.$toastr.e(error);
      //     })
      //     .finally(() => {
      //       this.preloader = false;
      //       $("#demo-add-edit-Modal").modal("hide");
      //       this.$hub.$emit("reload-" + this.tableId);
      //     });
        this.save(this.inputs);
    },
    afterSuccess(response) {
      this.$toastr.s(response.data.message);
      this.$hub.$emit("reload-" + this.tableId);
    },

    afterSuccessFromGetEditData(response) {
      if (response.data.phone) this.phone = response.data.phone;
      this.inputs = response.data;
      this.preloader = false;
    },
    getForms() {
      axiosGet(BUYER_CERTIFICATE_FORMS)
        .then((res) => {
          this.forms = res.data;
        })
        .catch((error) => {
          
        });
    },
    refreshForm() {
      this.refreshShow = false;
      this.getForms();

    },
    createForm() {
      this.refreshShow = true;
      window.open('/admin/documentlibrary/mydocument', '_blank');
    },
  },
  mounted() {
    // let myLocation = location.href;
    // let split = myLocation.split("/");
    // let id = split[6].split("?")[0];
    // let id = this.$attrs['props'].id;
    this.inputs.job_id = this.id;
    this.getForms();
    $(function () {
      $("#removeclass .modal-dialog ").removeClass("modal-dialog-scrollable");
    });
  },
};
</script>
